import { Metadata_NumberCategory$reflection, Metadata_NumberCategory, Metadata_StringCategory$reflection, Metadata_StringCategory } from "../../../../Shared/Shared.js";
import { class_type } from "../../../../fable_modules/fable-library.3.7.9/Reflection.js";

export class Tid extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "tid";
    }
}

export function Tid$reflection() {
    return class_type("Corpora.Bb.MetadataCategories.Tid", void 0, Tid, Metadata_StringCategory$reflection());
}

export function Tid_$ctor_Z721C83C5(aName) {
    return new Tid(aName);
}

export class Name extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "name";
    }
}

export function Name$reflection() {
    return class_type("Corpora.Bb.MetadataCategories.Name", void 0, Name, Metadata_StringCategory$reflection());
}

export function Name_$ctor_Z721C83C5(aName) {
    return new Name(aName);
}

export class Sex extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "sex";
    }
}

export function Sex$reflection() {
    return class_type("Corpora.Bb.MetadataCategories.Sex", void 0, Sex, Metadata_StringCategory$reflection());
}

export function Sex_$ctor_Z721C83C5(aName) {
    return new Sex(aName);
}

export class Age extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "age";
    }
}

export function Age$reflection() {
    return class_type("Corpora.Bb.MetadataCategories.Age", void 0, Age, Metadata_NumberCategory$reflection());
}

export function Age_$ctor_Z721C83C5(aName) {
    return new Age(aName);
}

export class Place extends Metadata_StringCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "place";
    }
}

export function Place$reflection() {
    return class_type("Corpora.Bb.MetadataCategories.Place", void 0, Place, Metadata_StringCategory$reflection());
}

export function Place_$ctor_Z721C83C5(aName) {
    return new Place(aName);
}

export class Episode extends Metadata_NumberCategory {
    constructor(aName) {
        super(aName);
    }
    ["Shared.Metadata.Category.get_Code"]() {
        return "episode";
    }
}

export function Episode$reflection() {
    return class_type("Corpora.Bb.MetadataCategories.Episode", void 0, Episode, Metadata_NumberCategory$reflection());
}

export function Episode_$ctor_Z721C83C5(aName) {
    return new Episode(aName);
}

